var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import client from "@irati/utils/services/apollo";
import dealsQuery, { dealListQueryKey } from "./queries/dealList";
export var search = function (params, options) {
    var limit = params.limit, q = params.q, geo = params.geo, slim = params.slim, lat = params.lat, lng = params.lng, insideBoundingBox = params.insideBoundingBox, radius = params.radius;
    var variables = { limit: limit, q: q, geo: geo, slim: slim, lat: lat, lng: lng, radius: radius };
    if (params.boundingBox) {
        variables.insideBoundingBox = params.boundingBox;
        variables.geo = true;
        variables.slim = true;
    }
    if (insideBoundingBox) {
        if (typeof insideBoundingBox === "string") {
            variables.insideBoundingBox = insideBoundingBox.split(",");
        }
        else {
            variables.insideBoundingBox = insideBoundingBox;
        }
    }
    return client.query(__assign({ query: dealsQuery, variables: variables }, options)).then(function (_a) {
        var data = _a.data;
        return {
            data: {
                results: {
                    deals: data[dealListQueryKey].results,
                    total: data[dealListQueryKey].count
                },
                q: q,
                lat: lat,
                lng: lng,
                radius: radius,
                boundingBox: insideBoundingBox
            }
        };
    });
};
